import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import './index.css';
import App from './App';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 2,
      refetchOnWindowFocus: false, // Don't refetch when switching back to tab
      staleTime: 5 * 60 * 1000, // 5 minutes - less frequent updates
      cacheTime: 10 * 60 * 1000, // 10 minutes cache
      refetchOnMount: false, // Don't refetch when component mounts if data exists
      refetchOnReconnect: false, // Don't refetch on network reconnect
    },
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// Auto-hide scrollbar functionality
(function() {
  let scrollTimeout: NodeJS.Timeout;
  
  function handleScroll(element: Element) {
    // Add scrolling class
    element.classList.add('scrolling');
    
    // Clear existing timeout
    clearTimeout(scrollTimeout);
    
    // Set timeout to remove class after scrolling stops
    scrollTimeout = setTimeout(() => {
      element.classList.remove('scrolling');
    }, 1000); // Hide after 1 second of no scrolling
  }
  
  // Add scroll listeners to all scrollable elements
  function addScrollListeners() {
    // Body scroll
    document.addEventListener('scroll', () => handleScroll(document.documentElement));
    
    // All elements with overflow scroll/auto
    const scrollableElements = document.querySelectorAll('*');
    scrollableElements.forEach(element => {
      const style = window.getComputedStyle(element);
      if (style.overflow === 'scroll' || style.overflow === 'auto' || 
          style.overflowY === 'scroll' || style.overflowY === 'auto' ||
          style.overflowX === 'scroll' || style.overflowX === 'auto') {
        element.addEventListener('scroll', () => handleScroll(element));
      }
    });
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addScrollListeners);
  } else {
    addScrollListeners();
  }
  
  // Re-scan for new scrollable elements periodically (for dynamic content)
  setInterval(addScrollListeners, 5000);
})(); 